import { TFunction } from 'i18next';

export const GenderOptions = (t: TFunction) => [
  { label: t('Not Specified'), value: '0' },
  { label: t('Male'), value: '1' },
  { label: t('Female'), value: '2' },
];

export const EntityTypeOptions = (t: TFunction) => [
  { label: t('Individual'), value: '0' },
  { label: t('Corporate'), value: '1' },
];

export const TaxableOptions = (t: TFunction) => [
  { label: t('Calculate Tax'), value: '1' },
  { label: t('Do Not Calculate Tax'), value: '0' },
];
